<!-- hasta aca los cambios -->
<template>
  <v-container fluid class="cbc-analyzer-container">
    <!-- Barra de encabezado con datos del usuario -->
    <v-app-bar app color="white" dark>
      <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo"></v-img>


      <template v-if="isMobile">
        <v-btn icon @click="showPatientInfo = !showPatientInfo">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>

      <!-- En dispositivos grandes, los datos del usuario y los botones son visibles en el encabezado -->
      <template v-else>
        <v-spacer></v-spacer>

        <v-select v-model="selectedGender" :label="$t('DatosP.genero')" :items="genders" class="mr-3" outlined dense
          :disabled="true"></v-select>
        <v-text-field v-model="age" :label="$t('DatosP.edad')" class="mr-3" outlined dense
          :disabled="true"></v-text-field>
        <v-text-field v-model="weight" :label="$t('DatosP.peso')" class="mr-3" outlined dense
          :disabled="true"></v-text-field>
        <v-text-field v-model="height" :label="$t('DatosP.estatura')" class="mr-3" outlined dense
          :disabled="true"></v-text-field>
        <v-select v-model="selectedEthnicity" :items="ethnicities" :label="$t('DatosP.etnia')" outlined dense
          :disabled="true"></v-select>
        <v-btn :href="'/'" color="primary" class="mr-3">
          <v-icon left>mdi-logout</v-icon>
          {{ $t('app.logout') }}
        </v-btn>
        <v-btn :href="`/usuarios/editar/${this.idUsuario}`" color="primary" class="mr-3">
          <v-icon left>mdi-logout</v-icon>
          {{ $t('app.actualizar') }}
        </v-btn>

        <v-btn v-if="rol === 2" :href="'/maestros'" color="primary" class="mr-3">
          <v-icon left>mdi-logout</v-icon>
          {{ $t('app.maestroParametros') }}
        </v-btn>
        <v-btn v-if="rol === 2" :href="'/DesEnfermedades'" color="primary" class="mr-3">
          <v-icon left>mdi-logout</v-icon>
          {{ $t('app.maestroEnfermedades') }}
        </v-btn>
      </template>
    </v-app-bar>

    <!-- Navegación lateral para dispositivos móviles -->
    <v-navigation-drawer v-model="showPatientInfo" temporary right>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">{{ $t('app.datosPaciente') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Campos de datos -->
        <v-list-item>
          <v-select v-model="selectedGender" :items="genders" :label="$t('DatosP.genero')" outlined dense
            :disabled="true" />
        </v-list-item>
        <v-list-item>
          <v-text-field v-model="age" :label="$t('DatosP.edad')" outlined dense :disabled="true" />
        </v-list-item>
        <v-list-item>
          <v-text-field v-model="weight" :label="$t('DatosP.peso')" outlined dense :disabled="true" />
        </v-list-item>
        <v-list-item>
          <v-text-field v-model="height" :label="$t('DatosP.estatura')" outlined dense :disabled="true" />
        </v-list-item>
        <v-list-item>
          <v-select v-model="selectedEthnicity" :items="ethnicities" :label="$t('DatosP.etnia')" outlined dense
            :disabled="true" />
        </v-list-item>

        <!-- Botones también dentro del drawer -->
        <v-divider class="my-2" />
        <v-list-item>
          <v-btn :href="'/'" color="primary" block>
            <v-icon left>mdi-logout</v-icon>
            {{ $t('app.logout') }}
          </v-btn>
        </v-list-item>
        <v-list-item v-if="rol === 2">
          <v-btn :href="'/maestros'" color="primary" block>
            <v-icon left>mdi-logout</v-icon>
            {{ $t('app.maestroParametros') }}
          </v-btn>
        </v-list-item>
        <v-list-item v-if="rol === 2">
          <v-btn :href="'/DesEnfermedades'" color="primary" block>
            <v-icon left>mdi-logout</v-icon>
            {{ $t('app.maestroEnfermedades') }}
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


    <!-- Cuerpo Principal -->
    <v-row class="mt-5">
      <!-- Publicidad Izquierda (Visible solo en pantallas grandes) -->
      <v-col cols="12" sm="1" class="advertisement left-ad" v-if="!isMobile">
      </v-col>

      <!-- Panel Principal -->
      <v-col :cols="isMobile ? 12 : 10">
        <v-row style="margin: 0;" class="flex-container">
          <!-- Izquierda 70% -->
          <v-col :cols="isMobile ? 12 : 7" class="principal">

            <v-card class="analyzer-card" style="border-radius: 4em;">
              <v-card-title class="text-center"
                style="font-size:3em; font-family:Georgia, 'Times New Roman', Times, serif;">Analizador
                ABG</v-card-title>
              <!-- Fishbone Analyzer Diagram -->

              <div class="fishbone-container">
                <v-row class="mt-4" align="center" :justify="isMobile ? 'end' : 'start'">
                  <v-col cols="auto">
                    <v-btn @click="realizarcalculo" class="fishbone-input btn">
                      {{ $t('app.calcular') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-text-field v-model="fields.ph" label="Ph" outlined dense class="fishbone-input ph"></v-text-field>
                <v-text-field v-model="fields.paco2" label="PaCO2" outlined dense
                  class="fishbone-input paco2"></v-text-field>
                <v-text-field v-model="fields.alb" label="Alb" outlined dense class="fishbone-input alb"></v-text-field>
                <v-text-field v-model="fields.na" label="Na(mEq/L)" outlined dense
                  class="fishbone-input na"></v-text-field>
                <v-text-field v-model="fields.cl" label="Cl(mEq/L)" outlined dense
                  class="fishbone-input cl"></v-text-field>
                <v-text-field v-model="fields.hco3" label="HCO3(mEq/L)" outlined dense
                  class="fishbone-input hco3"></v-text-field>

              </div>
              <v-btn @click="clearFields" color="orange" class="mt-4" block>
                {{ $t('app.limpiarcampos') }}
              </v-btn>

            </v-card>

          </v-col>



          <!-- Derecha 30% -->
          <v-col :cols="isMobile ? 12 : 5" class="right-panel">
            <v-card class="data-card" style="max-height:fit-content">
              <v-card-title class="text-center" style="background-color:transparent; font-size:2.5em ; color: white;">{{
                $t('app.diagnostico') }}</v-card-title>
              <v-row dense style="align-items: center">
                <v-col cols="12" v-for="(item, index) in additionalData" :key="index">
                  <v-card class="data-box position-relative" outlined v-if="item.value">

                    <v-card-actions>
                      <v-btn text color="primary" @click="openBanner(item.label, item.value)">
                        {{ $t('app.verdetalles') }}
                      </v-btn>
                    </v-card-actions>

                    <v-card-text :class="item.value === 'Normal' ? 'green-text' : 'red-text'">
                      {{ $t('app.diagnostico') }} {{ item.label }}: {{ item.value }}
                    </v-card-text>

                    <!-- ÍCONO DE ALERTA: solo aparece si NO es normal -->
                    <v-icon v-if="item.value !== 'Normal'" class="alert-icon" color="yellow" size="32">
                      mdi-alert-circle
                    </v-icon>

                  </v-card>
                </v-col>
              </v-row>

              <!-- Dialogo para mostrar el "banner" -->
              <v-dialog v-model="showBanner" max-width="600">
                <v-card class="banner-card rounded-xl elevation-6 pa-4">
                  <!-- Título principal -->
                  <v-card-title class="banner-title text-h5 font-weight-bold pb-2">
                    {{ selectedLabel }}
                  </v-card-title>

                  <v-card-text>
                    <v-expansion-panels focusable inset>
                      <v-expansion-panel v-for="(info, i) in bannerData" :key="i" class="banner-panel">
                        <v-expansion-panel-header class="banner-panel-header">
                          <span class="text-subtitle-1 font-weight-bold">{{ info.title }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="banner-panel-content">
                          <v-list dense class="banner-list">
                            <v-list-item v-for="(detail, j) in info.details" :key="j" class="banner-list-item">
                              <v-list-item-content>
                                <v-list-item-title class="banner-text">
                                  <span class="bullet">•</span> {{ detail }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>

                  <v-card-actions class="justify-end">
                    <v-btn color="primary" variant="flat" class="close-btn" @click="showBanner = false">
                      {{ $t('app.cerrar') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-card class="data-box" outlined v-if="infusionRate">
                <v-card-text>Tasa de Infusión: {{ infusionRate }}</v-card-text>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Publicidad Derecha (Visible solo en pantallas grandes) -->
      <v-col cols="12" sm="1" class="advertisement right-ad" v-if="!isMobile">
      </v-col>
    </v-row>

    <!-- Publicidad Inferior -->
    <v-row class="advertisement botton-ad mt-4">
      <v-col cols="12">
      </v-col>
    </v-row>
  </v-container>
</template>

<!-- un cambio mas arriba -->
<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL;


export default {

  setup() {
    const parametros = ref({});
    const cargarParametros = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/parameters`);

        const data = response.data;
        const parametrosMap = {
          paco2: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
          alb: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
          na: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
          cl: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
          hco3: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' }
        };

        data.forEach((param) => {
          switch (param.parametro.toLowerCase()) {
            case 'ph':
              parametrosMap.ph = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',   // Si no existe, se asigna un valor vacío
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
            case 'paco2':
              parametrosMap.paco2 = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
            case 'alb':
              parametrosMap.alb = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
            case 'na':
              parametrosMap.na = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
            case 'cl':
              parametrosMap.cl = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
            case 'bic': // "hco3" no está en los datos, pero "Bic" es el bicarbonato (HCO3)
              parametrosMap.hco3 = {
                valorMostrado: param.valorMostrado,
                valorAlto: param.valorAlto || '',
                valorBajo: param.valorBajo || '',
                units: param.units || '',
                rango: param.rango || ''
              };
              break;
          }
        });
        parametros.value = parametrosMap;

        console.log(parametros.value);  // Accede a valorMostrado de paco2
        console.log(parametros.value.paco2.valorMostrado);  // Accede a valorMostrado de paco2

        localStorage.setItem('parametros', JSON.stringify(parametros.value));
      } catch {
        console.error('Error al cargar parámetros:', error);
        console.log('Error al cargar parámetros:', error);
      }
    };
    onMounted(() => {
      const savedParams = localStorage.getItem('parametros');
      if (savedParams) {
        parametros.value = JSON.parse(savedParams);
      }

      cargarParametros();
    });

    return { parametros };
  },

  data() {
    return {
      showBanner: false, // Estado del banner
      selectedLabel: "", // Etiqueta seleccionada
      bannerData: [], // Información detallada del banner
      showPatientInfo: false,
      aniongap: 0,
      fields: {
        ph: '',
        paco2: '',
        alb: '',
        na: '',
        cl: '',
        hco3: ''
      },
      selectedGender: null,
      age: null,
      weight: null,
      height: null,
      selectedEthnicity: null,

      idUsuario: null,
      idioma: null,
      diagnosisOne: '',
      diagnosisOneDesc: '',
      diagnosisPlt: '',
      diagnosisPltDesc: '',
      additionalData: [

        { label: 'Anion Gap', value: '' },
        { label: 'Ph', value: '' },
        { label: 'PaCO2', value: '' },
        { label: 'Alb', value: '' },
        { label: 'Na', value: '' },
        { label: 'Cl', value: '' },
        { label: 'HCO3', value: '' },
        { label: 'Primary', value: '' },
        { label: 'Secondary', value: '' },

      ],
      // Variables necesarias para la tasa de infusión
      genderVal: null,
      weightVal: null,
      ageVal: null,
      ivna: null,
      ivk: null,
      naChange: null,
      infusionRate: null, // Para guardar la tasa de infusión calculada
      individualDiagnoses: [], // Nuevo arreglo para guardar diagnósticos individuales

      diagnostico1: '',
      diagnostico2: ''
    };
  },
  computed: {

    isMobile() {
      return this.$vuetify.display.mdAndDown;
    },

    // Lógica para calcular diagnósticos según los valores
    diagnosis() {
      const ph = this.convertToNumber(this.fields.ph);
      const paco2 = this.convertToNumber(this.fields.paco2);
      const alb = this.convertToNumber(this.fields.alb);
      const na = this.convertToNumber(this.fields.na);
      const cl = this.convertToNumber(this.fields.cl);
      const hco3 = this.convertToNumber(this.fields.hco3);


      this.additionalData[0].value = this.calcularAnionGap();
      this.additionalData[1].value = ph ? this.evaluateph(ph) : '';
      this.additionalData[2].value = paco2 ? this.evaluatepaco2(paco2) : '';
      this.additionalData[3].value = alb ? this.evaluatealb(alb) : '';
      this.additionalData[4].value = na ? this.evaluatena(na) : '';
      this.additionalData[5].value = cl ? this.evaluatecl(cl) : '';
      this.additionalData[6].value = hco3 ? this.evaluatehco3(hco3) : '';

    }

  },
  methods: {

    clearFields() {
      // Limpiar los campos de texto
      this.fields.ph = '';
      this.fields.paco2 = '';
      this.fields.alb = '';
      this.fields.na = '';
      this.fields.cl = '';
      this.fields.hco3 = '';

      // Limpiar los datos dentro de additionalData
      this.additionalData.forEach(item => {
        if (item.label !== 'Diagnostico Primario' && item.label !== 'Diagnostico Secundario') {
          item.value = ''; // Limpiar solo los valores de los otros campos
        }
      });

      // Hacer desaparecer "Diagnóstico Primario" y "Diagnóstico Secundario"
      const primary = this.additionalData.find(item => item.label === 'Diagnostico Primario');
      const secondary = this.additionalData.find(item => item.label === 'Diagnostico Secundario');
      if (primary) {
        primary.value = '';
      }
      if (secondary) {
        secondary.value = '';
      }
    },
    openBanner(label, value) {
      this.selectedLabel = label;
      this.showBanner = true;

      axios.get(`${apiUrl}/api/enfermedades/filter?enfermedad=${value}`)
        .then(response => {
          const enfermedad = response.data[0]; // asumimos que es único

          if (enfermedad) {
            this.bannerData = [
              {
                title: "Differential Diagnosis",
                details: enfermedad.descripcion
                  ? enfermedad.descripcion.split('\n').map(str => str.trim()).filter(Boolean)
                  : [this.$t('Errores.sinDescripcion')]
              },
              {
                title: "Workup",
                details: enfermedad.tratamiento
                  ? enfermedad.tratamiento.split('\n').map(str => str.trim()).filter(Boolean)
                  : [this.$t('Errores.sinTratamiento')]
              },
            ];
          } else {
            this.bannerData = [
              {
                title: this.$t('Errores.sinInfobd'),
                details: [this.$t('Errores.sinInfobd')],
              },
            ];
          }
        })
        .catch(error => {
          console.error(this.$t('Errores.sinDatos'), error);
          this.bannerData = [
            {
              title: "Error",
              details: [this.$t('Errores.problemabd')],
            },
          ];
        });
    },

    fieldLabel(field) {
      const labels = {
        ph: 'Ph',
        paco2: 'PaCO2',
        alb: 'Alb',
        na: 'Na',
        cl: 'Cl',
        hco3: 'HCO3'
      };
      return labels[field] || field;
    },

    calcularAnionGap() {
      // Convertir los valores de los campos a números
      const ph = this.convertToNumber(this.fields.ph);
      const paco2 = this.convertToNumber(this.fields.paco2);
      const alb = this.convertToNumber(this.fields.alb);
      const na = this.convertToNumber(this.fields.na);
      const cl = this.convertToNumber(this.fields.cl);
      const hco3 = this.convertToNumber(this.fields.hco3);


      // Inicializar el anion gap
      let aniongap = 0;


      // Calcular el anion gap básico
      aniongap = na - cl - hco3;

      // Ajustar el anion gap si la albumina es válida y menor que 4
      if (!isNaN(alb) && alb < this.parametros.alb.valorMostrado) {
        console.log("Ajustando anion gap por albumina");
        aniongap += 2.4 * (alb - 4);
      }

      console.log("este es aniongap", aniongap)
      return aniongap;
    },

    async addevaluated() {

      const ph = this.convertToNumber(this.fields.ph);
      const paco2 = this.convertToNumber(this.fields.paco2);
      const alb = this.convertToNumber(this.fields.alb);
      const na = this.convertToNumber(this.fields.na);
      const cl = this.convertToNumber(this.fields.cl);
      const hco3 = this.convertToNumber(this.fields.hco3);

      const aniongap = this.calcularAnionGap();


      let mensaje = ''
      let mensaje2 = ''
      let exphco3 = 0
      let expco2 = 0
      let deltadelta = 0


      if (aniongap > 14) {

        console.log("anion gap es mayor a 14")


        mensaje = 'Anion Gap Metabolic Acidosis'
        deltadelta = (aniongap - 12) + (hco3 - 24)

        if (deltadelta >= 3) {
          mensaje2 = 'Metabolic Alkalosis'
        } else if (deltadelta < 3 || deltadelta > -3) {
          mensaje2 = ''
        } else if (deltadelta <= -3) {
          mensaje2 = 'Primary Metabolic Acidosis'
        }

        expco2 = (1.5 * hco3) + 8


      }
      else if (aniongap < 14) {
        console.log("anion gap es menor a 14")

        if (hco3 >= this.parametros.hco3.valorBajo && hco3 <= this.parametros.hco3.valorAlto) {
          console.log("entre a esto entre 22 y 26 ")
          /* aqui paco era >=43 */
          if (paco2 >= this.parametros.paco2.valorMostrado) {
            console.log("pago es mayor a 43")
            if (ph <= 7.27) {
              mensaje = 'Acute Respiratory Acidosis'
              exphco3 = 24 + (paco2 - 40 / 10)
            }
            else if (ph >= 7.28) {
              mensaje = 'Chromic Respiratory Acidosis'
              exphco3 = 24 + ((paco2 - 40 / 10) * 3)
            }

          } else if (paco2 > this.parametros.value.paco2.valorBajo || paco2 < this.parametros.paco2.valorMostrado) {
            mensaje = ''
          } else if (paco2 <= this.parametros.paco2.valorBajo) {
            if (ph <= 7.51) {
              mensaje = 'Respiratory Alkalosis'
              exphco3 = 24 - ((paco2 - 4 / 10) * 5)
            }
            else if (ph >= 7.52) {
              mensaje = 'Chromic Respiratory Alkalosis'
              exphco3 = 24 - ((paco2 - 4 / 10) * 2)
            }
          }

          let deltahco3 = hco3 - exphco3

          if (deltahco3 >= 3) {
            mensaje2 = 'Metabolic Alkalosis'
          } else if (deltahco3 >= -2 && deltahco3 <= 2) {
            mensaje2 = ''
          } else if (deltahco3 <= -3) {
            mensaje2 = 'Metabolic Acidosis'
          }

        } else if (hco3 >= this.parametros.hco3.valorAlto) {
          console.log("hco3 es mayor o igual 27")
          expco2 = (0.7 * (hco3 - 24)) + 40

          let deltapco2 = paco2 - expco2
          if (deltapco2 >= 3) {
            mensaje = 'Respiratory Acidosis'
          } else if (deltapco2 > -2 || deltapco2 < 2) {
            mensaje = ''
          } else if (deltapco2 <= -3) {
            mensaje = 'Respiratory Alkalosis'
          }

        } else if (hco3 <= this.parametros.hco3.valorBajo) {
          console.log("hco3 es menor a 21")
          expco2 = (1.5 * hco3) + 8

          let deltapco2 = paco2 - expco2
          console.log("esto es deltapaco2", deltapco2)

          if (deltapco2 >= 3) {
            mensaje = 'Respiratory Acidosis'
          } else if (deltapco2 > -2 || deltapco2 < 2) {
            mensaje = ''
          } else if (deltapco2 <= -3) {
            mensaje = 'Respiratory Alkalosis'
          }
        }

      }

      this.additionalData[7].value = mensaje || '';
      this.additionalData[8].value = mensaje2 || '';

      return { mensaje, mensaje2 };
    },

    realizarcalculo() {
      this.addevaluated();

    },


    convertToNumber(value) {
      if (typeof value === 'string' && value.endsWith('K')) {
        return parseInt(value.slice(0, -1)) * 1000;
      }
      return parseFloat(value);
    },
    resetForm() {
      for (let field in this.fields) {
        this.fields[field] = ''; // Reset all fields to empty
      }
    },
    // Métodos de evaluación para cada campo
    evaluateph(phval) {
      if (phval < 7.42) return 'ph Low';
      else if (phval > 7.37) return 'ph High';
      return 'Normal';
    },
    evaluatepaco2(paco2) {
      if (paco2 >= this.parametros.paco2.valorMostrado) return 'paco2 High';
      else if (paco2 <= this.parametros.paco2.valorBajo) return 'paco2 Low';
      return 'Normal';
    },
    evaluatealb(albVal) {

      if (albVal >= this.parametros.alb.valorAlto) return 'Alb High';
      else if (albVal <= this.parametros.alb.valorBajo) return 'Alb Low';
      return 'Normal';
    },
    evaluatena(naVal) {
      if (naVal >= this.parametros.na.valorAlto) return 'Na High';
      else if (naVal <= this.parametros.na.valorBajo) return 'Na Low';
      return 'Normal';
    },
    evaluatecl(clVal) {
      if (clVal >= this.parametros.cl.valorAlto) return 'Cl High';
      else if (clVal <= this.parametros.cl.valorBajo) return 'Cl Low';
      return 'Normal';
    },
    evaluatehco3(hco3Val) {
      if (hco3Val >= this.parametros.hco3.valorAlto) return 'hco3 High';
      else if (hco3Val <= this.parametros.hco3.valorBajo) return 'hco3 Low';

      return 'Normal';
    },
    // Cálculo de la tasa de infusión
    calculateInfusionRate() {
      if (this.ageVal && this.weightVal && this.genderVal) {
        const naChange = this.naChange;
        const ivna = this.ivna;
        const ivk = this.ivk;
        const naValTemp = 140; // Usar un valor predeterminado para Na

        let waterFraction;
        if (this.ageVal < 60) {
          waterFraction = this.genderVal === "male" ? 0.6 : 0.5;
        } else {
          waterFraction = this.genderVal === "male" ? 0.5 : 0.45;
        }

        // Fórmula de ejemplo para la tasa de infusión
        const infusionRate = (1000 * naChange * (waterFraction * this.weightVal)) / (ivna + ivk - naValTemp);
        this.infusionRate = Math.round(infusionRate * 100) / 100;
      } else {
        this.teaseBasicInfo();
      }
    },
    teaseBasicInfo() {
      alert('Complete los datos básicos de la persona antes de continuar.');
    }
  },

  watch: {
    fields: {
      handler: async function () {
        this.diagnosis
      },
      deep: true
    }
  },


  mounted() {
    // Asignar valores desde Vuex a las variables del componente
    this.selectedGender = this.$store.state.user.gender;
    this.age = this.$store.state.user.age;
    this.weight = this.$store.state.user.weight;
    this.height = this.$store.state.user.height;
    this.selectedEthnicity = this.$store.state.user.ethnicity;
    this.idUsuario = this.$store.state.user.idusuario;
    this.idioma = this.$store.state.user.idioma;

    const savedParams = localStorage.getItem('parametros')
    console.log(this.idioma)
  }

};

</script>

<style scoped>
/* Tarjeta principal */

.green-text {
  color: darkgreen;
}

.red-text {
  color: red;
}

.position-relative {
  position: relative;
}

.alert-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.banner-card {
  background: linear-gradient(145deg, #f9fafb, #f1f5f9);
  border: 1px solid #e2e8f0;
}

/* Título */
.banner-title {
  color: #1e293b;
  border-bottom: 2px solid #3b82f6;
  padding-bottom: 0.5rem;
}

/* Panel */
.banner-panel {
  margin-bottom: 8px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

/* Header del panel */
.banner-panel-header {
  background-color: #f3f4f6;
  font-weight: bold;
  color: #334155;
}

/* Contenido con fondo */
.banner-panel-content {
  background: linear-gradient(135deg, #eef2ff, #f8fafc);
  padding: 0.75rem;
  border-left: 4px solid #3b82f6;
  /* Franja azul decorativa */
}

/* Lista */
.banner-list {
  padding-left: 0.5rem;
}

.banner-list-item {
  transition: background-color 0.2s ease;
  border-radius: 6px;
}

.banner-list-item:hover {
  background-color: #f1f5f9;
}

/* Texto */
.banner-text {
  font-weight: 500;
  /* un poco más grueso */
  color: #1e293b;
}

/* Bullet */
.bullet {
  color: #3b82f6;
  font-size: 1.2rem;
  margin-right: 6px;
}

/* Botón cerrar */
.close-btn {
  text-transform: none;
  font-weight: 600;
}

.botton-ad {
  background-image: url('../../images/bajamicro.jpg');
  /* Cambia a la ruta de tu imagen o GIF */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 50em;
  /* Altura fija */
  max-width: 100%;
  /* Asegura que no desborde horizontalmente */
  overflow: hidden;
}

.right-ad {
  background-image: url('../../images/izquierda.avif');
  /* Cambia a la ruta de tu imagen o GIF */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 50em;
  /* Altura fija */
  max-width: 100%;
  /* Asegura que no desborde horizontalmente */
  overflow: hidden;
}

.left-ad {
  background-image: url('../../images/izquierda.avif');
  /* Cambia a la ruta de tu imagen o GIF */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 50em;
  /* Altura fija */
  max-width: 100%;
  /* Asegura que no desborde horizontalmente */
  overflow: hidden;
}

.banner-card {
  background-image: url('../../images/abg.jpg');
  background-size: cover;
  background-position: center;
  color: white;
}

.banner-overlay {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 16px;
  border-radius: 8px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.principal {
  flex: 1 0 140px;

}

.right-panel {
  background-color: transparent;
  flex: 1 0 120px;
}






/* Fondo completo para la página */
.cbc-analyzer-container {
  background-image: url('../../images/dregradadonaranja.jpg');
  background-size: cover;
  /* Hace que la imagen de fondo cubra todo el área */
  background-position: center;
  /* Centra la imagen */
  min-height: 100vh;
  /* Hace que la altura mínima sea el 100% de la pantalla */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}



/* Estilos generales de la interfaz */
.cbc-analyzer-container {
  background-color: #f0f0f0;
}

.advertisement {
  background-color: #d3d3d3;
  /*     opacity: 0.2; */
  min-height: 2em;
  text-align: center;
}

.analyzer-card {
  background-color: transparent;
  color: white;
  padding: 20px;


}

/* Estilos del diagrama tipo fishbone */
.fishbone-container {
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #00aaff; */
  background-image: url('../../images/abg.png');
  background-size: 90%;
  background-position: center 50%;
  background-repeat: no-repeat;
  border-radius: 1em;
}

.fishbone-input {
  position: absolute;
  /* width: 80px; */
  text-align: center;
  background-color: white;
  color: grey;
  border-radius: 5%;
  font-weight: 900;
  max-height: 3em;
  min-width: 5.5em;
}

.data-box {
  background-color: white;
  /* Fondo blanco */
  border-radius: 12px;
  /* Bordes redondeados */
  border: 1px solid #374b40;
  /* Borde azul claro */
  margin-bottom: 10px;
  /* Separación entre los cuadros */
  padding: 10px;
  text-align: center;
  max-width: 25em;
  align-items: center
}

/* Estilo para el texto dentro de los cuadros */
.diagnosis-text {
  color: #00aaff;
  /* Color de texto celeste */
  font-weight: bold;
  /* Texto en negrita */
  font-size: 1.2rem;
  /* Aumentar tamaño de la fuente */
}

/* Contenedor donde se encuentra la imagen */
.fishbone-container {
  position: relative;
  width: 100%;
  height: 400px;
  /* Mantén un tamaño adecuado o ajusta */
  background-color: #c5972d;
  /* Opcional, para que puedas ver el área de la imagen */
}

/* Estilo de la imagen */
.analyzer-background {
  position: absolute;
  top: -60px;
  /* La imagen comienza en la parte superior */
  left: 45%;
  /* Centrado horizontalmente */
  transform: translateX(-50%);
  /* Asegura que esté completamente centrada */
  width: 100%;
  /* O puedes ajustar el ancho según sea necesario */
  height: auto;
  /* Mantiene las proporciones de la imagen */
}

.data-card {
  background-color: transparent;
  /* Fondo semi-transparente */
}

/* Media Queries para pantallas más pequeñas */
/* Media Queries para pantallas más pequeñas */
@media(min-width:900px) {

  /* Posicionamiento de cada cuadro de entrada en el diagrama */
  .ph {
    top: 33%;
    left: 20%;
  }

  .paco2 {
    top: 33%;
    left: 47%;
  }

  .alb {
    top: 33%;
    left: 75%;
  }

  .na {
    top: 53%;
    right: 75%;
  }

  .cl {
    top: 53%;
    Left: 40%;
  }

  .hco3 {
    top: 53%;
    left: 70%;
  }

  .btn {
    top: 1%;
    left: 75%;
    background-color: #FFA500;
    /* Color naranja suave */
    border-radius: 20px;
    /* Redondeo de las esquinas */
    color: white;
    /* Color de texto blanco */
    padding: 10px 20px;
    /* Espaciado interno para hacer el botón más grande */
    border: none;
    /* Elimina el borde predeterminado */
    cursor: pointer;
    /* Cambia el cursor a mano al pasar sobre el botón */
    transition: background-color 0.3s ease;
    /* Transición suave en el cambio de color */
  }

  .btn:hover {
    background-color: #FF7F32;
    /* Un naranja más oscuro para el hover */
  }




}

@media (max-width: 900px) {
  .fishbone-container {
    background-image: none;
    /* Solo oculta la imagen de fondo, no el contenedor */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
    gap: 8px;

  }

  .fishbone-input {
    position: relative;
    width: 90%;
    margin: 5px 0;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }


  .flex-container {
    display: flex;
    flex-direction: column;
    /* Cambia a columna */
    align-items: center;
  }

  .principal {
    width: 100%;
  }

  .right-panel {
    width: 100%;
  }

  .advertisement.left-ad {
    order: -1;
    /* Coloca la publicidad izquierda arriba */
  }

  .advertisement.right-ad {
    order: 2;
    /* Coloca la publicidad derecha abajo */
  }

  .logo {
    width: 100px;
    /* Hace el logo más pequeño en pantallas pequeñas */
    margin-left: 0;
    margin-right: auto;
  }

  .advertisement h1 {
    font-size: 1.5em;
    /* Reduce el tamaño del texto en la publicidad */
  }

  .data-card {
    padding: 15px;
  }

  .diagnosis-text {
    font-size: 1rem;
    /* Ajusta el tamaño del texto de diagnóstico */
  }

  .data-box {
    font-size: 0.9em;
    /* Ajusta el tamaño de las cajas de datos */
  }

  .analyzer-card {
    padding: 10px;
  }
}
</style>